import { useNavigate } from '@tanstack/react-router'

import { usePositions } from '../hooks'
import { PositionsList } from './PositionsList'

interface ConnectedPositionsListProps {
  className?: string
  openRole?: string
  openLevel?: string
  initialPositionId?: string
}

export const ConnectedPositionsList = ({
  className,
  openRole,
  openLevel,
  initialPositionId,
}: ConnectedPositionsListProps) => {
  const navigate = useNavigate()
  const { groupedPositions, isLoading, isError, error, refetch, isRefetching } = usePositions()

  const handleViewQuestions = (
    positionId: string,
    positionTitle: string,
    positionLevel: string,
    positionRole: string,
  ) => {
    navigate({
      to: `/positions/${positionId}/questions`,
      search: {
        title: positionTitle,
        level: positionLevel,
        role: positionRole,
      },
    })
  }

  return (
    <PositionsList
      groupedPositions={groupedPositions}
      isLoading={isLoading}
      isError={isError}
      error={error}
      onViewQuestions={handleViewQuestions}
      isRefetching={isRefetching}
      onRetry={() => refetch()}
      className={className}
      openRole={openRole}
      openLevel={openLevel}
      initialPositionId={initialPositionId}
    />
  )
}
